export default __webpack_public_path__ + "media/zurb/img/home/home-process-img1-ac617a26b550bd367d2aeab7cfc450e2.png";